export var IndexType;
(function (IndexType) {
    IndexType["Rw"] = "Rw";
    IndexType["Lnw"] = "Lnw";
    IndexType["Value\u0394Rw"] = "\u0394Rw";
})(IndexType || (IndexType = {}));
export var RuIndexTypeNamesSelectValues = [
    { label: 'Rw', value: IndexType.Rw },
    { label: 'Lnw', value: IndexType.Lnw },
    { label: 'ΔRw', value: IndexType.ValueΔRw },
];
